import { TileMeta, createBlankTileMeta } from "./models"
import { validateBlockingRects } from "./tile_blocking_geometry"

export interface TiledProperty {
    name: string
    type?: string
    value: any
}
export interface TiledTile {
    id: number
    properties?: TiledProperty[]
}

/**
 * The id MapUtil gives a parent whose `compositeTileIdParent` is empty: a fresh uuid, so no other
 * tile joins it and it is a one-cell composite. A stable stand-in here, for the same effect.
 */
export const unnamedCompositeId = (tilesetId: string, id: number) => `${tilesetId}#${id}`

/** MapUtil.process's parse of one tileset's tiles, keyed `tile.id + 1` as it keys them. */
export const tilesetTileMeta = (tilesetId: string, tiles: TiledTile[] = []): Record<number, TileMeta> => {
    const meta: Record<number, TileMeta> = {}
    tiles.forEach(tile => {
        const tileId = tile.id + 1
        let tileMeta: TileMeta = meta[tileId]
        if (!tileMeta) {
            tileMeta = createBlankTileMeta()
            meta[tileId] = tileMeta
        }
        ;(tile.properties || []).forEach(p => {
            if (p.name === "blockingRects") tileMeta.blockingRects = validateBlockingRects(JSON.parse(p.value))
            if (p.name === "blocking" && p.value === true) tileMeta.tileTypes.push("blocking")
            if (p.name === "deep" && p.value === true) tileMeta.tileTypes.push("deep")
            if (p.name === "lava" && p.value === true) tileMeta.tileTypes.push("lava")
            if (p.name === "floor" && p.value === true) tileMeta.tileTypes.push("floor")
            if (p.name === "compositeTileId" && !!p.value) {
                tileMeta.tileTypes.push("hidden")
                tileMeta.compositeTileId = p.value
            }
            if (p.name === "compositeTileIdParent") {
                tileMeta.compositeTileId = p.value || unnamedCompositeId(tilesetId, tile.id)
                tileMeta.compositeTileParent = true
            }
            if (p.name === "breakageMeta" && !!p.value) tileMeta.breakageMeta = JSON.parse(p.value)
            if (p.name === "compositeTileDense" && p.value === true) {
                tileMeta.compositeTileParent = true
                tileMeta.tileTypes.push("dense")
            }
            if (p.name === "densityStrategy" && !!p.value) tileMeta.tileTypes.push(p.value)
            if (p.name === "variant" && !!p.value) tileMeta.variant = p.value
            if (p.name === "malleable" && p.value === true) {
                tileMeta.malleable = true
                tileMeta.tileTypes.push("entityTile")
            }
            if (p.name === "spriteId" && !!p.value) tileMeta.spriteId = p.value
            if (p.name === "entityTileId" && !!p.value) {
                tileMeta.entityTileId = p.value
                tileMeta.tileTypes.push("entityTile")
            }
            if (p.name === "renderZIdxOffset" && !!p.value) tileMeta.renderZIdxOffset = Number(p.value)
            if (p.name === "renderYOffset" && !!p.value) tileMeta.renderYOffset = Number(p.value)
            if (p.name === "renderXOffset" && !!p.value) tileMeta.renderXOffset = Number(p.value)
        })
    })
    return meta
}

